import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { TransportTypesPage } from '@/pages/transport-types/TransportTypesPage'

export const Route = createFileRoute('/transport-types')({
  component: () => (
    <RequirePermission section="dictionaries" action="view">
      <TransportTypesPage />
    </RequirePermission>
  ),
})
